const formatDate = (
  date,
  options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }
) => {
  return new Date(date).toLocaleDateString(navigator.language, options);
};

export default formatDate;
